import React, { Fragment } from 'react';
import { ApolloError } from '@apollo/client';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CircularProgress from 'components/@common/CircularProgress';
import ErrorCard from 'components/@common/ErrorCard';

export interface PageContainerProps {
  children?: React.ReactNode;
  loading?: boolean;
  error?: ApolloError | string | null;
  showChildrenWhileLoading?: boolean;
}

const useStyles = makeStyles(() => {
  return {
    root: {
      height: '100%',
      background: '#eee'
    }
  };
});

const PageContainer = ({
  loading,
  error,
  children,
  showChildrenWhileLoading = false
}: PageContainerProps): React.ReactElement => {
  const classes = useStyles();

  if (loading) {
    return (
      <>
        <CircularProgress loading={loading} />
        {showChildrenWhileLoading && children}
      </>
    );
  }

  if (error) {
    return (
      <Grid container justify="center" alignItems="center" className={classes.root}>
        <ErrorCard />
      </Grid>
    );
  }

  return <Fragment>{children}</Fragment>;
};

export default PageContainer;
